import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function getViewALL(viewType) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllByViewType/${viewType}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewType(viewType, id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewTypeBySearch(viewType, id, search) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}?search=${search}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewPagination(viewType, id, page, limit) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}?page=${page}&limit=${limit}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewPaginationSearch(viewType, id, page, limit, search) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}?page=${page}&limit=${limit}&search=${search}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getByViewId(id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getByViewId/${id}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getQueryFieldsByType(type, page) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getQueryFields/${type}/${page}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteViewId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteView/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ViewSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createView`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
const getAllRelatedEntity = async (Entity, type) => {
    try {
        const data = await getAxiosInstance().get(`/Template/getAllRelatedEntity/${Entity}/${type}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ViewUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateView/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchDataPagination(payload, entity, page, limit) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}?page=${page}&limit=${limit}`, payload, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchDataSearch(payload, entity, search) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}?search=${search}`, payload, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchDataPaginationSearch(payload, entity, page, limit, search) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}?page=${page}&limit=${limit}&search=${search}`, payload, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchData(payload, entity) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}`, payload, { headers });
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    getViewType,
    getViewALL,
    ViewSave,
    ViewUpdate,
    getByViewId,
    deleteViewId,
    getViewTypeBySearch,
    getQueryFieldsByType,
    getViewPagination,
    getViewPaginationSearch,
    queryFetchData,
    queryFetchDataSearch,
    queryFetchDataPagination,
    queryFetchDataPaginationSearch,
    getAllRelatedEntity,
}